<template>
    <div>
        <v-tabs>
            <v-tab @click="handleActiveTab('fxSpot')">{{ $t('plexus.tabs.fxSpot') }}</v-tab>
            <v-tab  @click="handleActiveTab('ndf')">{{ $t('plexus.tabs.fxNdf') }}</v-tab>
            <v-tab v-if="false" @click="activeTab = 'commodities'">{{ $t('quoteInfo.commodities') }}</v-tab>
        </v-tabs>
        <div class="mt-2 pa-3" no-gutters>
            <v-row no-gutters class="justify-center">
                <v-col cols="10" class="d-flex justify-center flex-gap-8">

                    <!--settlement or maturity-->
                    <div>
                        <div v-if="activeTab === 'fxSpot'">
                            <FxSpot :loadingNewRfq="loadingNewRfq" :gridActive="gridActive" @change="handleChange" />
                        </div>
                        <div v-if="activeTab === 'ndf'">
                            <FxNdf :loadingNewRfq="loadingNewRfq" :gridActive="gridActive"
                                @ndfChange="handleNdfChange" />
                        </div>

                        <div v-if="false">
                            <Commodities :loadingNewRfq="loadingNewRfq" :gridActive="gridActive" @side=""
                                @selectedCommodity="" />
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row class="justify-center">

                <v-col v-if="activeTab !== 'commodities'" cols="10"
                    class="d-flex flex-gap-4 align-baseline justify-center">
                    <v-text-field v-model="amount" v-money="money" :key="amountFieldKey"
                        :label="$t('quoteInfo.amountCcy')" :disabled="loadingNewRfq || gridActive" class="mr-md-2"
                        style="max-width: 300px;" @input="handleAmountChange">
                    </v-text-field>
                    <!-- v-money="money"-->
                    <v-btn elevation="0" tile color="primary" @click="handleQuote" :loading="loadingNewRfq" outlined
                        :disabled="disableQuoteButton" class="mt-2 rounded">
                        <span :class="disableQuoteButton ? 'text--disabled' : 'white--text'">{{
                            $t('quoteInfo.quote') }}</span>
                    </v-btn>
                </v-col>

                <!-- <v-col cols="10" class="d-flex flex-gap-4 align-baseline justify-center" v-else>
                    <v-text-field @input="handleAmountChange" v-model="volume" v-money="money" :key="activeTab"
                        :label="$t('quoteInfo.volumeBushels')" :disabled="loadingNewRfq || gridActive" class="mr-md-2"
                        @focus="volume === 0 && (volume = '')" style="max-width: 300px;">
                    </v-text-field>

                    <v-btn elevation="0" outlined color="primary" @click="handleQuote" :loading="loadingNewRfq"
                        :disabled="disableQuoteButton" class="mt-2 mt-md-0">
                        {{ $t('quoteInfo.quote') }}
                    </v-btn>
                </v-col> -->
            </v-row>
        </div>
    </div>
</template>
<script>
import { VMoney } from "v-money"
import FxSpot from '../components/FxSpot.vue';
import FxNdf from '../components/FxNdf.vue';


export default {
    directives: {
        money: VMoney
    },
    components: {
        FxSpot,
        FxNdf
    },
    data() {
        return {
            activeTab: "fxSpot",
            amount: 0,
        }
    },
    props: ["loadingNewRfq", "gridActive", "volume", "disableQuoteButton", "amountFieldKey"],
    watch: {
        amountFieldKey() {
            this.amount = 0;
        }
    },
    computed: {
        money() {
            return {
                thousands: ","
            }
        },
    },
    methods: {
        handleChange(v) {
            this.$emit("handle-change", v)
        },
        handleNdfChange(v) {
            this.$emit("handle-ndf-change", v)
        },
        handleActiveTab(v) {
            this.activeTab = v;
            this.$emit("handle-active-tab", v)
        },
        handleAmountChange() {
            this.$emit("amount-change", this.amount);
        },
        handleQuote() {
            this.$emit("handle-quote", { amount: this.amount })
        }
    }
}
</script>